import React from "react";
import { Box, Stack, Button, Typography, IconButton } from "@mui/material";
import PageHeader from "./../../components/PageHeader";
import MusicRow from "../../components/MusicRow";
import ApiService from "./../../services/api-service";
import Loader from "./../../components/Loader";
import Nodata from "./../../components/Nodata";
import { getUserId, getUserDetail } from "../../constants/function";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import AddIcon from "@mui/icons-material/Add";
import { useHistory } from "react-router-dom";
import SuccessPopup from "./../../components/SuccessPopup";
import WarningPopup from "../../components/WarningPopup";
import { useTranslation } from "react-i18next";
export default function AddFeatureMusic() {
  const { t } = useTranslation("common");
  const history = useHistory();
  const [warning, setWarning] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [musics, setMusics] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const userId = getUserId();
  const [topMusic, setTopMusic] = React.useState([]);

  const userDetail = getUserDetail();
  const getFeatueMusic = async () => {
    try {
      setLoading(true);
      const response = await ApiService.MY_MUSIC(`assetId=${userId}&type=user`);

      getTopFiveMusic(response["result"]);
      setMusics([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getTopFiveMusic = (data) => {
    data.forEach((m, index) => {
      if (userDetail["top5Music"]) {
        userDetail["top5Music"].forEach((t, i) => {
          if (t["_id"] === m["_id"]) {
            data[index]["isTopFive"] = true;
            handleChecked(m["_id"], true, index);
          }
        });
      }
    });
  };

  React.useEffect(() => {
    getFeatueMusic();
  }, []);

  const handleChecked = (id, e, i) => {
    // console.log(id, e, i);
    const index = topMusic.indexOf(i);
    if (index >= 0) {
      const m = topMusic;
      m.splice(index, 1);
      const temp = musics;
      setTopMusic([...m]);
    } else {
      const m = topMusic;
      m.push(i);
      setTopMusic([...m]);
    }
    if (topMusic.length > 5) {
      setWarning(true);
    }
  };

  const addFeatureMusic = async () => {
    try {
      setLoading(true);
      const payload = { topMusic: {} };
      topMusic.forEach((m, index) => {
        payload["topMusic"][index + 1] = musics[m]["_id"];
      });
      const response = await ApiService.ADD_TOP_MUSIC(payload);

      setLoading(false);
      setOpen(true);
      setTimeout(() => {
        history.push("/app/Profile");
      }, 1000);
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <Box>
      <Stack spacing={1} margin="0 18px 5px" borderBottom="1px solid #262626">
        <Box
          sx={{
            color: "#999999",
            display: "flex",
            alignItems: "center",
          }}
          className="_cp fs-14"
          onClick={() => history.goBack()}
        >
          <ArrowBackIosIcon className="fs-14" sx={{ color: "#999999" }} />{" "}
          {t("back")}
        </Box>
        <Typography sx={{ marginBottom: "5px !important" }}>
          {t("myProfile.addFeatures")}
        </Typography>
      </Stack>
      <Box className="__main_pading" sx={{ position: "relative" }}>
        <Stack
          spacing={1}
          sx={{ height: "calc(100vh - 166px)", overflow: "scroll" }}
        >
          {musics.length > 0 ? (
            musics.map((music, index) => (
              <MusicRow
                key={index}
                index={index}
                onChecked={(id, e, i) => handleChecked(id, e, i)}
                music={music}
                isChecked={music["isTopFive"]}
                isCheckbox={true}
                disabled={topMusic.length === 5}
              />
            ))
          ) : (
            <Nodata />
          )}
        </Stack>
        {musics.length > 0 ? (
          <Box
            sx={{
              position: "absolute",
              top: "-57px",
              right: 0,
              padding: "0 21px",
            }}
          >
            <Button
              onClick={addFeatureMusic}
              variant="contained"
              color="primary"
              disabled={topMusic.length > 5}
              startIcon={<AddIcon color="secondary" />}
            >
              {t("uploadMusic.input10.button")}
            </Button>
          </Box>
        ) : null}
      </Box>
      {loading ? <Loader /> : null}
      {open ? (
        <SuccessPopup
          open={open}
          message={t("success.message3")}
          handleClose={() => setOpen(false)}
        />
      ) : null}
      {warning ? (
        <WarningPopup
          message={t("warning.message1")}
          open={warning}
          handleClose={() => {
            setWarning(false);
          }}
        />
      ) : null}
    </Box>
  );
}
